import React from "react";
import Navbar from "../Components/Navbar/Navbar";
import Footerr from "../Components/Footer/Footerr";
import Busdetay from "../Components/Jojobus/Busdetay";
import Bushero from "../Components/Jojobus/Bushero";
import Jojocarosel from "../Components/Jojobus/Jojocarosel";
import transition from "../transition";

const Jojobus = () => {
  return (
    <div>
      <Navbar />
      <Bushero />
      <Busdetay />
      <Jojocarosel />
      <Footerr />
    </div>
  );
};

export default transition(Jojobus);
